import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderHs2 from "../../../../commons/components/Header/headerHs2";
import LazyLoadImg from "../../../../commons/components/LazyLoadImg";
import Loading from "../../../../commons/components/Loading";
import DialogComponent from "../../../../commons/components/Modal/DialogComponent";
import ROUTERS from "../../../../commons/constans/router";
import { useAlbumDetail, useResetAlbumDetail } from "../../../../commons/customHooks/Album";
import { useMyAwardEntry } from "../../../../commons/customHooks/Award";
import useCallSocket from "../../../../commons/customHooks/useCallSocket";
import useHover from "../../../../commons/customHooks/useHover";
import MainLayout from "../../../../commons/layout/MainLayout";
import { formatDateTimeStringKorea } from "../../../../utils/helpers";
import NavigateImg from "./navigateImg";

type props = {
  deleteAlbum: Function
};

const AlbumDetailComponent = ({deleteAlbum}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [onShow, setOnShow] = useState(false);
  const location = useLocation();
  const param = useParams();
  const {userInfo} = useSelector((state) => state.authReducers);
  const [statusDialog, setStatusDialog] = useState(false);
  const [ myEntry ] = useMyAwardEntry();
  const [albumDetail, loadingAlbumDetail] = useAlbumDetail(param.step);
  const dateTimeString = albumDetail?.created_at ? formatDateTimeStringKorea(albumDetail?.created_at) : '';
  const [statusNoti, setStatusNoti] = useState({
    status: false,
    msg: ''
  });
  const [popupDeletedImg, setPopupDeletedImg] = useState(false);
  useResetAlbumDetail()

  useEffect(() =>{
    console.log(albumDetail, 'albumDetail');
    if (loadingAlbumDetail === false && !albumDetail?.id) {
      // setPopupDeletedImg(true);
    }
  }, [albumDetail])

  const handleShowEvent = () => {
    setOnShow(!onShow)
  }

  const backToPage = () => {
    console.log(location,location.search, 'locationlocationlocation');
    if (location && location.search === '?kakaolink') {
      navigate(ROUTERS.ALBUM);
    }else{
      navigate(-1);
    }
  }

  const callDeleteAlbum = (data) => {
    setStatusDialog(true);
    // 
  }

  const handleDelete = () => {
    dispatch(deleteAlbum({id: albumDetail?.id || null}))
    setStatusDialog(false);
    if (location && location.search === '?kakaolink') {
      navigate(ROUTERS.ALBUM);
    }else{
      navigate(-1);
    }
  }

  const handleClose = () => {
    setStatusDialog(false);
  }

  const goToRankingPage = () => {
    // navigate(ROUTERS.AWARD);
    navigate(ROUTERS.AWARD_REGISTER, {state: {photoSelected: albumDetail}});
  }

  const callShowInfo = () => {
    let data = formatDateTimeStringKorea(albumDetail.created_at);
    setStatusNoti({
      status: true,
      msg: dateTimeString.fullDateTime
    })
    // setStatusNoti(true)
  }

  const handleCloseNoti = () => {
    setStatusNoti(false)
  }

  const handleClosePopupNotiDeleted = () => {
    setPopupDeletedImg(true);
    navigate(ROUTERS.HOME);
  }


  return (
    <>
      <MainLayout
        pageID={"album-photo-detail-page"}
        displayBottomNav={false}
        activeNav={"ALBUM"}
      >
        {onShow ? 
         <HeaderHs2 
          leftChildShow={``}
          title={dateTimeString.dateYear}
          titleDate={dateTimeString.timeStr}
          labelRight={!myEntry?.id && userInfo.id === albumDetail.user_id ? `랭킹참여` : null}
          labelLeft={true}
          handleLabelRight={() => goToRankingPage()}
          handleLabelLeft={() => backToPage()}        
        />
        : <></>}
        {
          loadingAlbumDetail ? <Loading /> : <div className="wrapper d-flex align-items-center" onClick={() => handleShowEvent()}>
          <LazyLoadImg src={albumDetail?.photo_url?.original || ""} className="img-full-screen"/>
        </div>
        }
        
        {onShow && userInfo.id === albumDetail.user_id ? 
          <NavigateImg albumDetail={albumDetail} callDeleteAlbum={callDeleteAlbum} callShowInfo={callShowInfo}/>
        : <></>}
        <DialogComponent 
          id={`js-delete-album`} 
          children={``} 
          show={statusDialog} 
          title={`알림`} 
          closeBtn={`취소`}
          customBtn={`확인`}       
          handleCustom={handleDelete}  
          handleClose={handleClose}
          className={`dialog-custom-button`}
        >
          <div className="content-dialog">
          정말 삭제하시겠습니까? <br />
          삭제 후에는 사진 복구가 불가능합니다. 
          </div>
        </DialogComponent>
        <DialogComponent 
          id={`js-noti-album`} 
          show={statusNoti.status} 
          title={`정보`} 
          closeBtn={`확인`}
          handleClose={handleCloseNoti}
        >
          <div className="content-dialog">
          {statusNoti?.msg || ''} <br />
          {albumDetail?.location || ''}
          </div>
        </DialogComponent>

        <DialogComponent 
          id={``} 
          children={``} 
          show={popupDeletedImg} 
          title={`알림`} 
          closeBtn={`확인`}
          handleClose={handleClosePopupNotiDeleted}
        >
          <div className="content-dialog">
          제작자가 사진을 삭제하였음으로 해당 사진을 볼 수 없습니다.
          </div>
        </DialogComponent>

      </MainLayout>
    </>
  );
};

export default AlbumDetailComponent;
